jQuery(document).ready(function($) {
  
  // alert(MODULE.publicProperty);
  // MODULE.init();
  
  // jstree.init();
  // actions.init();
  // lists.init();
  // game.init();
  // console.log('hello');
  $('input[type="range"]').ionRangeSlider({
      skin: "round",
      // hide_min_max: true,
      // hide_from_to: true,
  });
  // console.log('hello');

  // var rellax = new Rellax('.rellax');



  $('.inview').on('inview', {offsetTop:50}, function(event, visible) {
      if (visible) {
        // $(this).removeClass('hidden');
        $(this).addClass('fadein');
        // $(this).fadeIn();
        // TweenMax.to(marker,1,{css:{left:pos,opacity:1},ease:Power2.easeOut});
          //in view
          // TweenMax.to($(this),0.5,{opacity:1});
      } else {
        // $(this).css('opacity',0);
          //out view
        // $(this).hide();
        $(this).removeClass('fadein');
        // $(this).addClass('hidden');
      }
  });



  // PREVENT CLICK ON ANY # LINK
  $('body').on('click', 'a[href="#"]', function(event) {
    event.preventDefault();
  });




  // RESPONSIVE TABLES
  // this sorts the html by cloning the table on top, removing all but first
  // col and freezing it. leaving the bottom layer to scroll horizontally.
  $.each($(".main-table"), function(index, val) {
    var scrollableTable = $(this).clone(true);
    var tableScroll = $(this).closest('.table-scroll');
    // scrollableTable.addClass('dragscroll');
    scrollableTable.addClass('clone');
    scrollableTable.appendTo(tableScroll);   
  });



  // DRAGGABLE PANEL THINGS - anything that overflows bascially. can drag.
  $('.table-scroll .table-wrap').addClass('dragscroll');
  $('.table-scroll .table-wrap').addClass('dragscroll_at_start');
  $('.table-scroll .table-wrap.dragscroll').scroll(function() {

     if($(this).scrollLeft() + $(this).width() == $(this).width()) {
         // console.log("hit left");
      $(this).removeClass('dragscroll_scrolling');
         $(this).addClass('dragscroll_at_start');
     } else if($(this).scrollLeft() >= ($(this).find('.main-table').width() - $(this).width())) {
         // console.log("hit right");
      $(this).removeClass('dragscroll_scrolling');
         $(this).addClass('dragscroll_at_end');
     } else {
      $(this).removeClass('dragscroll_at_end');
      $(this).removeClass('dragscroll_at_start');
      $(this).addClass('dragscroll_scrolling');
     }
  });


  $('.mobile-navigation').addClass('dragscroll');



  // function onDrag(e){
  //   // console.log('dragging table',this.target);
  //   // var table = $(this).find('.table-wrap');
  //   // this.fadeOut();
  //   var scrollLeft = this.target.closest('.table-wrap');
  //   console.log('dragging table',scrollLeft);

  // }

  //GSAP draggable
  // Draggable.create(".table-scroll .main-table", {type:"x", bounds:".table-scroll",onDrag:onDrag});




  // var pageHeader = document.getElementsByClassName('page-header')[0];
  //  if(pageHeader){window.addEventListener("scroll", function (event) {console.log(this.scrollY);
  //  scrollPageHeader(this.scrollY);
  //  });
  //  } function scrollPageHeader(scrollTop){
  //   var background = pageHeader.getElementsByClassName('background')[0];
  //  var overlay = pageHeader.getElementsByClassName('overlay')[0];
  //  var ratio = (scrollTop / 2);
  //  console.log(ratio);
  //  background.style.top = ratio+'px';
  //  background.style.bottom = '-'+ratio+'px';
  //  var fadeRatio = (scrollTop / 700);
  //  if(fadeRatio>1) fadeRatio=1;
  //  fadeRatio = fadeRatio*fadeRatio;
  //  overlay.style.opacity = fadeRatio;
  //  }



  //gravitfy forms, disable button upon submit
  // ONLY WORKS IF NOT USING AJAX!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  $('.gform_wrapper .gform_footer').on('click', 'input[type=submit]', function(e) {
    setTimeout(function(){
      $('.gform_wrapper .gform_footer input[type=submit]').attr("disabled", true).prop('value','Processing...');
    },1);
  });

  // $(document).bind('gform_confirmation_loaded', function(event, form_id){
  //   $('.gform_wrapper .gform_footer input[type=submit]').attr("disabled", true).prop('value','Processing...');
  // });




});

// ON LOAD
jQuery(window).one('load', function() {

  jQuery('body').addClass('loaded');

});



